import { motion } from "framer-motion";
import { MoveRight, Sprout, CookingPot, Network } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useApp } from "@/context/AppContext";

const ICONS = [Sprout, CookingPot, Network];

export const Ecosystem = () => {
  const { content, t } = useApp();
  const eco = content.ecosystem;

  return (
    <section id="ekosistem" data-testid="ecosystem-section" className="px-4 sm:px-8 lg:px-16 py-20 sm:py-28 bg-[#1E3A2B] relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#D96B27]/10 blur-3xl" />
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#E5B869] font-semibold">04 // {t(eco.heading)}</p>
      </Reveal>
      <div className="mt-4 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <Reveal delay={0.08}>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl lg:text-5xl text-[#FAF7F2] tracking-tight leading-[1.12]" data-testid="ecosystem-heading">
            {t(eco.heading)}
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:max-w-md">
          <p className="text-base text-[#FAF7F2]/65 leading-relaxed">{t(eco.intro)}</p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 lg:grid-cols-[1fr_auto_1fr_auto_1fr] items-stretch gap-6">
        {eco.steps.map((s, i) => {
          const Icon = ICONS[i] || Sprout;
          return (
            <div key={i} className="contents">
              <Reveal delay={0.1 * i}>
                <div
                  className="relative h-full rounded-2xl border border-[#FAF7F2]/12 bg-[#FAF7F2]/[0.04] backdrop-blur-sm p-7 sm:p-8 hover:bg-[#FAF7F2]/[0.08] hover:border-[#E5B869]/40 transition-colors duration-500"
                  data-testid={`ecosystem-step-${i}`}
                >
                  <div className="flex items-center justify-between">
                    <span className="w-11 h-11 rounded-full bg-[#D96B27] flex items-center justify-center">
                      <Icon size={19} className="text-[#FAF7F2]" />
                    </span>
                    <span className="font-mono text-xs text-[#E5B869]/70 tracking-widest">0{i + 1}</span>
                  </div>
                  <h3 className="mt-6 font-serif text-2xl font-semibold text-[#FAF7F2]">{t(s.title)}</h3>
                  <p className="mt-3 text-sm text-[#FAF7F2]/65 leading-relaxed">{t(s.body)}</p>
                </div>
              </Reveal>
              {i < eco.steps.length - 1 && (
                <div className="hidden lg:flex items-center justify-center">
                  <motion.div
                    initial={{ opacity: 0, x: -12 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.3 + 0.1 * i }}
                  >
                    <MoveRight size={26} className="text-[#E5B869]" />
                  </motion.div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};
